module.exports = __webpack_public_path__ + "static/media/reward.a472ad99.svg";